import {useMemo} from 'react';

import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface SplitsConfirmationHeaderProps {
  userName?: string;
  onGetAvatarImage: () => React.ReactNode;
}

export const SplitsConfirmationHeader = ({
  userName,
  onGetAvatarImage,
}: SplitsConfirmationHeaderProps) => {
  const {t} = useTranslation();

  const nameToShow = useMemo(
    () => userName || t('split_bills_page.confirmation.default_user'),
    [t, userName],
  );

  return (
    <Box className="splits-confirmation-header-in-app">
      {onGetAvatarImage()}
      <Typography
        className="splits-confirmation-greeting"
        component="h1">
        {t('split_bills_page.confirmation.greeting', {
          name: nameToShow,
        })}
      </Typography>
    </Box>
  );
};
